{
  "addFleet": "Add fleet",
  "table": {
    "empty": "No fleet found",
    "column": {
      "fleet": "Fleet",
      "devices": "Devices",
      "createdAt": "Created at",
      "updatedAt": "Updated at",
      "incompatibleDevices": "Incompatible devices",
      "information": {
        "incompatibleDevices": "Some devices of the fleet are not compatible with the current parameters.",
        "fleetHasChanged": "The fleet scope has been modified",
        "noDeviceCompatible": "No device of this fleet is compatible with the current campaign configuration"
      }
    }
  },
  "addDevices": "Add devices",
  "form": {
    "createFleet": {
      "header": "Create a new fleet",
      "validate": "Create fleet",
      "cancel": {
        "confirmMessage": "Are you sur you want to cancel the creation of the fleet?"
      }
    },
    "validation": {
      "name": "The name is mandatory",
      "uniqueName": "The fleet name must be unique"
    },
    "header": {
      "addDevices": "Add selected devices to a fleet",
      "createFleet": "Create a fleet"
    },
    "newFleet": "New fleet",
    "name": "Fleet name",
    "saveSuccess": "The {fleetName} fleet has been successfully created."
  },
  "attachDevices": {
    "updateSuccess": "No device added | The device addition to the {fleetName} fleet has been successful. | The devices addition to the {fleetName} fleet has been successful.",
    "title": "Attach devices to the fleet",
    "confirmMessage": "Are you sur you want to cancel the operation? Your selection will be lost."
  },
  "removeDevices": {
    "confirmMessage": "Are you sure you want to delete this device from this fleet? | Are you sure you want to delete this device from this fleet? | Are you sure you want to delete these devices from the fleet?",
    "confirmTitle": "Remove from fleet"
  },
  "actionForbidden": "You do not have the permission required for this action.",
  "delete": {
    "title": "Delete the fleet",
    "confirm": {
      "message": "Are you sure you want to delete the selected fleet?"
    }
  },
  "quickActions": {
    "selectedFleets": "No fleet selected | {count} fleet selected | {count} selected fleets",
    "delete": {
      "title": "No fleet to delete | Delete a fleet | Delete fleets"
    }
  },
  "bulkDelete": {
    "confirm": {
      "title": "No fleet to delete | Delete fleet | Delete fleets",
      "message": "No fleet to delete | Are you sure you want to delete the selected fleet? | Are you sure you want to delete the selected fleets?"
    }
  }
}
